import React from 'react';

function ToastNotifications({ toastMessage }) {
  if (!toastMessage.text) return null;

  return (
    <div className={`toast-message toast-${toastMessage.type}`}>
      {toastMessage.text}
    </div>
  );
}

export default ToastNotifications;
